<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {getdeviceId} from '@/publicResource/utils/utils'
export default {
  name: 'App',
  mounted () {
    getdeviceId() // 生成设备标识
  }
}
</script>

<style lang="scss">
    body {
        background-color: #f5f5f5;
    }
    #app {
        min-width: 1280px;
        height: 100%;
    }
    .el-container{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/module/index/index.vue